import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slider--right",
  "use": "icon-slider--right-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 36 36\" id=\"icon-slider--right\"><path fill=\"#fff\" fill-opacity=\".75\" d=\"M0 36h35.791V0H0z\" /><path d=\"m13.791 26 8.842-8-8.842-8\" stroke=\"#000\" stroke-width=\"2\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol